<template>
  <div class="flex-box" :class="{ 'no-flex': noFlex }">
    <div>
      <div>
        <img v-if="version < 999" src="../../../assets/image/user/login.png" />
        <p>
          <strong>丰富功能，扫码即用</strong>
          <img src="../../../assets/image/user/free.png" />
        </p>
      </div>
      <div style="margin-top: 15px;">
        <a @click="Login_Jump()" class="btn">{{ login_btn }}</a>
      </div>
      <p>
        <!-- <a  @click="close">取消</a> -->
      </p>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.close();
      }
    },
  },
  props: ['noFlex', 'version'],
  data() {
    return {
      visible: false,
      closed: false,
      login_btn: '登录/注册',
      callback: () => {},
    };
  },
  mounted() {},
  methods: {
    close() {
      this.callback && this.callback(this);
      this.$el.parentNode.removeChild(this.$el);
    },
    Login_Jump() {
      if (this.login_btn === '刷新登录状态') {
        this.$messenger.addTarget(window.parent, 'parent');
        this.$messenger.targets['parent'].send('Show_Login_JumpUrl_Message');
      } else {
        if (this.noFlex) {
          window.open('https://account.5118.com/signin?status=Plug');
          this.login_btn = '刷新登录状态';
          this.$messenger.addTarget(window.parent, 'parent');
          this.$messenger.targets['parent'].send(
            'Show_Login_BtnName_Message',
            '刷新登录状态'
          );
        } else {
          this.$messengernew.addTarget(window.parent, 'parent');
          this.$messengernew.targets['parent'].send(
            'Show_Login_JumpUrl_Message'
          );
        }
      }
    },
  },
};
</script>

<style scoped lang="less" type="text/less">
@import '../../../assets/style/color.less';
@import '../../../assets/style/config.less';

.flex-box {
  font-size: 14px;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 41px;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 2000;
  &.no-flex {
    position: absolute;
    top: 0;
  }
  .head {
    text-align: right;
    line-height: 40px;
    .close {
      display: inline-block;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      background-color: #cfcfcf;
      text-align: center;
      cursor: pointer;
      span {
        position: relative;
        top: -5px;
      }
    }
  }
  p {
    text-align: center;
    line-height: 25px;
    color: @theme-color;
  }
  .btn {
    font-size: 14px;
    padding: 0 30px;
    line-height: 28px;
    &:hover {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/LoginBox2/Main.vue